import React from 'react';

/*

   ---- This is just the component that tells them that they can brush the scatterplot to Zoom in ----

*/

export default function ZoomInfo({ 
  isVisible, 
  onToggle, 
  message = "If the dots on the scatter plot are scrunched up or difficult to see individually, you can drag your cursor over a section of the plot to zoom in.",
  className = "mt-8 mb-4 max-w-2xl"
}) {
  if (!isVisible) {
    return (
      <button
        className="text-blue-600 underline text-xs mb-4 ml-1"
        onClick={onToggle}
        aria-label="Show zoom info"
      >
        Show Info
      </button>
    );
  }

  return (
    <div className={`bg-blue-50 border-l-4 border-blue-300 px-4 py-2 rounded text-sm text-blue-800 ${className}`}>
      <div className="flex items-end justify-between">
        <div className="flex items-start">
          <svg className="w-4 h-4 mr-2 mt-0.5 flex-shrink-0 text-blue-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16v-4m0-4h.01" />
          </svg>
          <span>{message}</span>
        </div>
        <button className="text-blue-600 underline text-xs ml-4 flex-shrink-0" onClick={onToggle}>
          Hide
        </button>
      </div>
    </div>
  );
} 